import client from './client';

export const notificationsApi = {
  getAll: (params) => client.get('/notifications', { params }),
  markRead: (id) => client.put(`/notifications/${id}/read`),
  markAllRead: () => client.put('/notifications/read-all'),
  markAllReadByType: (type) =>
    client.put('/notifications/read-all-by-type', null, { params: { type } }),
  delete: (id) => client.delete(`/notifications/${id}`),
  getUnreadCount: () => client.get('/notifications/unread-count'),

  // Web push
  getVapidKey: () => client.get('/notifications/vapid-public-key'),
  subscribe: (subscription) =>
    client.post('/notifications/push-subscribe', { subscription }),
  unsubscribe: (endpoint) =>
    client.post('/notifications/push-unsubscribe', { endpoint }),

  // Per-user notification preferences (push_enabled, workout_reminders, ...).
  // The literal `/notifications/settings` is a separate admin-only endpoint for
  // *global* notification system config; do not call it here.
  getSettings: () => client.get('/notification-settings'),
  updateSettings: (data) => client.put('/notification-settings', data),
};
